import { IPublicClientApplication } from '@azure/msal-browser';
import { authenticateOnScope, checkValidResponse, scopeApi, UserSearchInfo } from '../services/common';

export const searchUsers = async (instance: IPublicClientApplication, searchTxt: string): Promise<UserSearchInfo[]> => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/roles/getUserSearchResult', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'text/plain'
        }),
        body: searchTxt
    });
    await checkValidResponse(response, "searchUsers");
    const data = await response.json();
    return data.map(x => ({ email: x.email, name: x.firstName + ' ' + x.lastName }));
};